import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { useWindowSize } from "go-core/components/useWindowSize";
import { UserApi } from "../../../../../../../../services/Api/types";
import { SupportOrganizationApi } from "../../../../../../../../services/support/types";
import OrganizationList from "../../components/OrganizationList";
import SearchOrganizationForm from "../../components/SearchOrganizationForm";
import UserList from "../../components/UserList";

const SupportSearchOrganizationIndexPage = () => {
	const { t } = useTranslation("admin");
	const [organizations, setOrganizations] = useState<SupportOrganizationApi[]>([]);
	const [users, setUsers] = useState<UserApi[]>([]);
	const [selectedSorts, setSelectedSorts] = useState<string[]>([]);
	const isMobile = useWindowSize().isMobile;
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.support.field.search_organization.title"));
	}, []);

	return (
		<div className="content">
			{!isMobile && <Header title={t("modules.support.field.search_organization.title")} />}
			<SearchOrganizationForm
				setOrganizations={setOrganizations}
				setUsers={setUsers}
				selectedSorts={selectedSorts}
			/>
			<OrganizationList data={organizations} setSelectedSorts={setSelectedSorts} selectedSorts={selectedSorts} />
			<UserList data={users} setSelectedSorts={setSelectedSorts} selectedSorts={selectedSorts} />
		</div>
	);
};

export default SupportSearchOrganizationIndexPage;
